import { Injectable } from "@angular/core";
import { UrlRepo } from "@app/core/urls/domain/url.repo";
import { TermsAndConditionsWS } from "@app/core/urls/data/network/terms-and-conditions.ws";
import { Observable } from "rxjs";
import { PrivacyPolicyWS } from "@app/core/urls/data/network/privacy-policy.ws";

/**
 * Repository used to get terms and conditions.
 */
@Injectable()
export class UrlDataRepo implements UrlRepo {
  constructor(
    private termsAndConditionsWS: TermsAndConditionsWS,
    private privacyPolicyWS: PrivacyPolicyWS
  ) {}
  getTermsAndConditions(): Observable<string> {
    return this.termsAndConditionsWS.execute();
  }

  getPrivacyPolicy(): Observable<string> {
    return this.privacyPolicyWS.execute();
  }
}
